
const en = {
  // General
  app_name: 'Support Portal',
  app_title: 'Ticket Management System',
  loading: 'Loading...',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  refresh: 'Refresh',
  search: 'Search',
  filter: 'Filter',
  export: 'Export',
  import: 'Import',
  actions: 'Actions',
  status: 'Status',
  no_data: 'No data',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Info',
  confirm: 'Confirm',
  yes: 'Yes',
  no: 'No',

  // Auth
  login: 'Login',
  logout: 'Logout',
  username: 'Username',
  password: 'Password',
  odoo_url: 'Odoo URL',
  odoo_db: 'Database',
  login_button: 'Sign In',
  login_error: 'Login failed. Check your credentials',
  login_success: 'Logged in successfully',
  session_expired: 'Session expired. Please login again',

  // Navigation
  nav_dashboard: 'Dashboard',
  nav_tickets: 'Tickets',
  nav_contacts: 'Contacts',
  nav_inventory: 'Inventory',
  nav_approvals: 'Approvals',
  nav_performance: 'Performance',
  nav_invoices: 'Invoices',
  nav_stock_notifications: 'Stock Alerts',
  nav_product_tracking: 'Product Tracking',
  nav_import: 'Import Tickets',
  nav_accounting: 'Accounting',
  nav_settings: 'Settings',
  nav_pos: 'Point of Sale',
  nav_sales: 'Sales',
  nav_purchases: 'Purchases',
  nav_crm: 'CRM',
  nav_employees: 'Employees',
  nav_attendance: 'Attendance',
  nav_payroll: 'Payroll',
  nav_manufacturing: 'Manufacturing',
  nav_field_service: 'Field Service',
  nav_training: 'Training',
  nav_products: 'Products',
  nav_warehouse: 'Warehouse',
  nav_spare_parts: 'Spare Parts',

  // Dashboard
  dashboard_title: 'Dashboard',
  total_tickets: 'Total Tickets',
  new_tickets: 'New Tickets',
  in_progress: 'In Progress',
  completed: 'Completed',
  cancelled: 'Cancelled',

  // Tickets
  tickets_title: 'Ticket Management',
  ticket_number: 'Ticket #',
  ticket_subject: 'Subject',
  ticket_customer: 'Customer',
  ticket_stage: 'Stage',
  ticket_priority: 'Priority',
  ticket_assigned: 'Assigned To',
  ticket_date: 'Date',
  ticket_external_ref: 'External Ref',
  ticket_address: 'Address',
  ticket_phone: 'Phone',
  ticket_problem: 'Problem',
  ticket_product: 'Product',
  ticket_model: 'Model',
  ticket_sap: 'SAP Number',
  ticket_central: 'Central',
  ticket_create: 'Create Ticket',
  ticket_detail: 'Ticket Details',
  ticket_messages: 'Messages',
  ticket_attachments: 'Attachments',
  priority_low: 'Low',
  priority_normal: 'Normal',
  priority_high: 'High',
  priority_urgent: 'Urgent',

  // Import
  import_title: 'Import Tickets',
  import_subtitle: 'Import maintenance reports from Excel or CSV files',
  import_dropzone: 'Drag & drop file here or click to browse',
  import_dropzone_hint: 'Supports Excel (.xlsx, .xls) and CSV files',
  import_dropzone_active: 'Drop the file here',
  import_file_selected: 'File selected',
  import_file_size: 'File size',
  import_file_rows: 'Number of rows',
  import_step_upload: 'Upload File',
  import_step_mapping: 'Column Mapping',
  import_step_preview: 'Preview Data',
  import_step_import: 'Import',
  import_step_results: 'Results',
  import_mapping_title: 'Map file columns to system fields',
  import_mapping_hint: 'Map each column in the file to the corresponding system field',
  import_mapping_auto: 'Auto Map',
  import_mapping_file_column: 'File Column',
  import_mapping_odoo_field: 'System Field',
  import_mapping_required: 'Required',
  import_mapping_unmapped: 'Unmapped',
  import_preview_title: 'Preview data before import',
  import_preview_hint: 'Review the data before starting the import',
  import_preview_duplicates: 'Duplicates',
  import_preview_valid: 'Valid for import',
  import_preview_errors: 'Errors',
  import_start: 'Start Import',
  import_starting: 'Importing...',
  import_progress: 'Import Progress',
  import_results_title: 'Import Results',
  import_results_success: 'Successfully imported',
  import_results_failed: 'Failed to import',
  import_results_duplicates: 'Duplicates',
  import_results_skipped: 'Skipped',
  import_results_total: 'Total',
  import_results_download_report: 'Download Report',
  import_new: 'New Import',
  import_history: 'Import History',
  import_history_empty: 'No import history',
  import_manual_title: 'Add Ticket Manually',
  import_manual_hint: 'Enter ticket data manually',
  import_manual_ref: 'External Ref *',
  import_manual_name: 'Customer Name',
  import_manual_phone: 'Phone Number',
  import_manual_address: 'Address',
  import_manual_problem: 'Problem',
  import_manual_product: 'Product',
  import_manual_model: 'Model',
  import_manual_sap: 'SAP Number',
  import_manual_central: 'Central',
  import_manual_submit: 'Submit Ticket',
  import_error_file_type: 'Unsupported file type',
  import_error_file_size: 'File size exceeds limit',
  import_error_parse: 'Failed to parse file',
  import_error_no_ref: 'External reference is required',
  import_error_exists: 'Ticket already exists',
  import_error_create: 'Failed to create ticket',

  // Auth - Enhanced
  email: 'Email',
  phone: 'Phone',
  login_email: 'Email',
  login_phone: 'Phone',
  login_method_email: 'Sign in with Email',
  login_method_phone: 'Sign in with Phone',
  show_password: 'Show password',
  hide_password: 'Hide password',
  remember_me: 'Remember me',
  advanced_settings: 'Advanced Settings',
  connection_settings: 'Connection Settings',
  login_subtitle: 'Sign in to continue',
  login_identifier_placeholder_email: 'admin@example.com',
  login_identifier_placeholder_phone: '01XXXXXXXXX',

  // Settings
  settings_title: 'Settings',
  settings_language: 'Language',
  settings_theme: 'Theme',
  settings_theme_light: 'Light',
  settings_theme_dark: 'Dark',
  settings_theme_system: 'System',
  settings_odoo: 'Connection Settings',
  settings_about: 'About',
  settings_config_keys: 'Configuration Keys',
  settings_config_desc: 'Manage app settings without modifying code',
  settings_config_key: 'Key',
  settings_config_value: 'Value',
  settings_config_default: 'Default',
  settings_config_overridden: 'Overridden',
  settings_config_reset: 'Reset',
  settings_config_reset_all: 'Reset All',
  settings_config_reset_confirm: 'Reset all settings to defaults?',
  settings_config_save: 'Save Settings',
  settings_config_saved: 'Settings saved',
  settings_config_reset_done: 'Reset complete',
  settings_connection_info: 'Connection Info',
  settings_odoo_url: 'Odoo URL',
  settings_odoo_db: 'Database',
  settings_backend_url: 'Backend URL',
  settings_user_info: 'User Info',
  settings_session: 'Session',

  // Notifications
  notifications: 'Notifications',
  notifications_empty: 'No notifications',
  notifications_clear_all: 'Clear All',
  notifications_mark_read: 'Mark as Read',
  notification_login_success: 'Logged in successfully',
  notification_logout: 'Logged out',
  notification_session_expired: 'Session expired. Please login again',
  notification_phone_not_found: 'No account found for this phone number',
  notification_rate_limited: 'Too many attempts. Please try again later',
  notification_ticket_created: 'Ticket created successfully',
  notification_ticket_updated: 'Ticket updated',
  notification_import_complete: 'Import completed successfully',
  notification_import_failed: 'Import failed',
  notification_config_loaded: 'Settings loaded from server',
  notification_config_error: 'Failed to load settings',

  // Security
  security_rate_limit: 'Too many login attempts',
  security_session_timeout: 'Session expired',
  security_unauthorized: 'Unauthorized',
  settings_server_config: 'Server Settings (Cloudflare)',
  settings_server_config_desc: 'These settings are controlled from Cloudflare dashboard',
  settings_source: 'Source',

  // ─── Sales Module ───
  sales_title: 'Sales Management',
  sales_quotation: 'Quotation',
  sales_order: 'Sales Order',
  sales_new: 'New Quotation',
  sales_customer: 'Customer',
  sales_date: 'Date',
  sales_amount: 'Amount',
  sales_state: 'Status',
  sales_salesperson: 'Salesperson',
  sales_team: 'Sales Team',
  sales_deadline: 'Delivery Date',
  sales_payment_term: 'Payment Terms',
  sales_draft: 'Draft',
  sales_sent: 'Sent',
  sales_confirmed: 'Confirmed',
  sales_done: 'Done',
  sales_cancel: 'Cancelled',
  sales_lines: 'Order Lines',
  sales_product: 'Product',
  sales_quantity: 'Quantity',
  sales_unit_price: 'Unit Price',
  sales_discount: 'Discount',
  sales_subtotal: 'Subtotal',
  sales_tax: 'Tax',
  sales_total: 'Total',
  sales_confirm_order: 'Confirm Order',
  sales_send_quotation: 'Send Quotation',

  // ─── Purchases Module ───
  purchases_title: 'Purchase Management',
  purchases_order: 'Purchase Order',
  purchases_new: 'New Purchase Order',
  purchases_vendor: 'Vendor',
  purchases_date: 'Date',
  purchases_amount: 'Amount',
  purchases_state: 'Status',
  purchases_buyer: 'Purchase Representative',
  purchases_planned_date: 'Planned Date',
  purchases_origin: 'Origin',
  purchases_to_approve: 'To Approve',
  purchases_confirm: 'Confirm Order',

  // ─── CRM Module ───
  crm_title: 'Customer Relationship Management',
  crm_lead: 'Lead / Opportunity',
  crm_opportunity: 'Opportunity',
  crm_new_lead: 'New Lead',
  crm_new_opportunity: 'New Opportunity',
  crm_contact_name: 'Contact Name',
  crm_email: 'Email',
  crm_phone: 'Phone',
  crm_stage: 'Stage',
  crm_probability: 'Probability',
  crm_expected_revenue: 'Expected Revenue',
  crm_planned_revenue: 'Planned Revenue',
  crm_source: 'Source',
  crm_campaign: 'Campaign',
  crm_medium: 'Medium',
  crm_deadline: 'Deadline',
  crm_won: 'Won',
  crm_lost: 'Lost',
  crm_lost_reason: 'Lost Reason',
  crm_new: 'New',
  crm_qualification: 'Qualification',
  crm_proposition: 'Proposition',
  crm_negotiation: 'Negotiation',
  crm_pipeline: 'Sales Pipeline',
  crm_convert: 'Convert to Opportunity',
  crm_won_action: 'Won',
  crm_lost_action: 'Lost',

  // ─── HR / Employees Module ───
  employees_title: 'Employee Management',
  employees_new: 'Add Employee',
  employees_name: 'Name',
  employees_department: 'Department',
  employees_job: 'Job Position',
  employees_manager: 'Manager',
  employees_email: 'Email',
  employees_phone: 'Phone',
  employees_mobile: 'Mobile',
  employees_status: 'Status',
  employees_active: 'Active',
  employees_absent: 'Absent',
  employees_on_leave: 'On Leave',
  employees_national_id: 'National ID',
  employees_hire_date: 'Hire Date',
  employees_salary: 'Salary',
  employees_allowances: 'Allowances',
  employees_deductions: 'Deductions',
  employees_net_salary: 'Net Salary',
  employees_gender: 'Gender',
  employees_birthday: 'Birthday',
  employees_marital: 'Marital Status',
  employees_contract: 'Contract',
  employees_contracts: 'Contracts',

  // ─── Attendance Module ───
  attendance_title: 'Attendance',
  attendance_check_in: 'Check In',
  attendance_check_out: 'Check Out',
  attendance_employee: 'Employee',
  attendance_check_in_time: 'Check In Time',
  attendance_check_out_time: 'Check Out Time',
  attendance_worked_hours: 'Worked Hours',
  attendance_today: 'Today\'s Attendance',
  attendance_late: 'Late',
  attendance_early: 'Early',
  attendance_absent: 'Absent',
  attendance_overtime: 'Overtime',

  // ─── Payroll Module ───
  payroll_title: 'Payroll Management',
  payroll_payslip: 'Payslip',
  payroll_new: 'New Payslip',
  payroll_employee: 'Employee',
  payroll_period: 'Period',
  payroll_date_from: 'From',
  payroll_date_to: 'To',
  payroll_gross: 'Gross Amount',
  payroll_net: 'Net Amount',
  payroll_state: 'Status',
  payroll_draft: 'Draft',
  payroll_verify: 'Under Review',
  payroll_done: 'Done',
  payroll_contract: 'Contract',
  payroll_structure: 'Salary Structure',
  payroll_run: 'Run Payroll',
  payroll_batch: 'Payslip Batch',

  // ─── Manufacturing Module ───
  manufacturing_title: 'Manufacturing Management',
  manufacturing_order: 'Manufacturing Order',
  manufacturing_new: 'New Manufacturing Order',
  manufacturing_product: 'Product',
  manufacturing_quantity: 'Quantity',
  manufacturing_state: 'Status',
  manufacturing_planned_start: 'Planned Start Date',
  manufacturing_planned_end: 'Planned End Date',
  manufacturing_responsible: 'Responsible',
  manufacturing_bom: 'Bill of Materials',
  manufacturing_workorders: 'Work Orders',
  manufacturing_origin: 'Origin',
  manufacturing_planned: 'Planned',
  manufacturing_progress: 'In Progress',
  manufacturing_confirm: 'Confirm',
  manufacturing_plan: 'Plan',

  // ─── Field Service Module ───
  field_service_title: 'Field Service',
  field_service_order: 'Field Service Order',
  field_service_new: 'New Work Order',
  field_service_employee: 'Technician',
  field_service_customer: 'Customer',
  field_service_scheduled_start: 'Scheduled Start',
  field_service_scheduled_end: 'Scheduled End',
  field_service_actual_start: 'Actual Start',
  field_service_actual_end: 'Actual End',
  field_service_location: 'Location',
  field_service_resolution: 'Resolution',
  field_service_parts_used: 'Parts Used',
  field_service_signature: 'Signature',
  field_service_priority: 'Priority',

  // ─── Training / Human Development ───
  training_title: 'Human Development',
  training_course: 'Training Course',
  training_new_course: 'Add Course',
  training_session: 'Training Session',
  training_trainer: 'Trainer',
  training_start_date: 'Start Date',
  training_end_date: 'End Date',
  training_duration: 'Duration (Hours)',
  training_category: 'Category',
  training_status: 'Status',
  training_attendees: 'Attendees',
  training_certificate: 'Certificate',
  training_location: 'Location',
  training_notes: 'Notes',

  // ─── Products Module ───
  products_title: 'Product Management',
  products_new: 'Add Product',
  products_name: 'Product Name',
  products_code: 'Code',
  products_barcode: 'Barcode',
  products_category: 'Category',
  products_price: 'Sale Price',
  products_cost: 'Cost',
  products_type: 'Type',
  products_stock: 'Stock',
  products_virtual_stock: 'Available Stock',
  products_incoming: 'Incoming',
  products_outgoing: 'Outgoing',
  products_tracking: 'Tracking',
  products_sale_ok: 'Can be Sold',
  products_purchase_ok: 'Can be Purchased',
  products_brand: 'Brand',

  // ─── Warehouse Module ───
  warehouse_title: 'Warehouse Management',
  warehouse_picking: 'Transfer Order',
  warehouse_new: 'New Transfer',
  warehouse_origin: 'Origin',
  warehouse_destination: 'Destination',
  warehouse_state: 'Status',
  warehouse_scheduled: 'Scheduled Date',
  warehouse_done: 'Completion Date',
  warehouse_type: 'Transfer Type',
  warehouse_receipt: 'Receipt',
  warehouse_delivery: 'Delivery',
  warehouse_internal: 'Internal',
  warehouse_validate: 'Validate',

  // ─── Spare Parts Module ───
  spare_parts_title: 'Spare Parts',
  spare_parts_available: 'Available Parts',
  spare_parts_requested: 'Requested Parts',
  spare_parts_ordered: 'Ordered Parts',
  spare_parts_ready: 'Ready Parts',
  spare_parts_used: 'Used Parts',
  spare_parts_product: 'Part',
  spare_parts_quantity: 'Quantity',
  spare_parts_ticket: 'Ticket',
  spare_parts_stock: 'Stock',

  // ─── Common Module Labels ───
  module_sales: 'Sales',
  module_purchases: 'Purchases',
  module_crm: 'CRM',
  module_hr: 'Human Resources',
  module_attendance: 'Attendance',
  module_payroll: 'Payroll',
  module_manufacturing: 'Manufacturing',
  module_field_service: 'Field Service',
  module_training: 'Training',
  module_inventory: 'Inventory',
  module_accounting: 'Accounting',
  module_pos: 'Point of Sale',
  module_tickets: 'Tickets',

  // ─── Dashboard Enhanced ───
  dashboard_sales_month: 'Monthly Sales',
  dashboard_purchases_month: 'Monthly Purchases',
  dashboard_new_leads: 'New Leads',
  dashboard_won_opportunities: 'Won Opportunities',
  dashboard_active_employees: 'Active Employees',
  dashboard_attendance_today: 'Today\'s Attendance',
  dashboard_open_invoices: 'Open Invoices',
  dashboard_overdue_invoices: 'Overdue Invoices',
  dashboard_manufacturing_orders: 'Manufacturing Orders',
  dashboard_pending_approvals: 'Pending Approvals',
  dashboard_stock_value: 'Stock Value',
  dashboard_low_stock: 'Low Stock',

  // ─── Invoice Lines Module ───
  invoice_lines: 'Invoice Lines',
  invoice_line_name: 'Line Description',
  invoice_line_product: 'Product',
  invoice_line_quantity: 'Quantity',
  invoice_line_unit_price: 'Unit Price',
  invoice_line_discount: 'Discount %',
  invoice_line_tax: 'Tax %',
  invoice_line_subtotal: 'Subtotal',
  invoice_line_total: 'Total',
  invoice_line_notes: 'Notes',
  invoice_add_line: 'Add Line',
  invoice_remove_line: 'Remove Line',
  invoice_calculate: 'Auto Calculate',
  invoice_no_lines: 'No lines',
  invoice_print: 'Print',
  invoice_link_ticket: 'Link to Ticket',

  // ─── Service Contract Module ───
  service_contract_title: 'Service Contracts',
  service_contract_new: 'New Contract',
  service_contract_partner: 'Customer',
  service_contract_product: 'Product',
  service_contract_start: 'Start Date',
  service_contract_end: 'End Date',
  service_contract_status: 'Status',
  service_contract_type: 'Contract Type',

  // ─── Spare Parts Module (Enhanced) ───
  spare_part_title: 'Spare Parts',
  spare_part_new: 'Add Part',
  spare_part_product: 'Product',
  spare_part_quantity: 'Quantity',
  spare_part_ticket: 'Ticket',
  spare_part_status: 'Status',

  // ─── Stock Movement Module ───
  stock_movement_title: 'Stock Movements',
  stock_movement_new: 'New Movement',
  stock_movement_type: 'Movement Type',
  stock_movement_source: 'Source',
  stock_movement_destination: 'Destination',
  stock_movement_date: 'Date',

  // ─── Tech Payment Module ───
  tech_payment_title: 'Tech Payments',
  tech_payment_new: 'New Payment Request',
  tech_payment_technician: 'Technician',
  tech_payment_amount: 'Amount',
  tech_payment_type: 'Payment Type',
  tech_payment_status: 'Status',
  tech_payment_date: 'Date',

  // ─── Technician Inventory Module ───
  technician_inventory_title: 'Technician Inventory',
  technician_inventory_product: 'Product',
  technician_inventory_quantity: 'Quantity',
  technician_inventory_technician: 'Technician',
  technician_inventory_location: 'Location',

  // ─── Field Service Module (Enhanced) ───
  field_service_title_enhanced: 'Field Service Orders',
  field_service_technician: 'Technician',
  field_service_status: 'Status',
  field_service_start: 'Start Work',
  field_service_end: 'End Work',

  // ─── Work Order Module ───
  work_order_title: 'Work Orders',
  work_order_new: 'New Work Order',
  work_order_status: 'Status',
  work_order_start: 'Start',
  work_order_end: 'End',

  // ─── Call History Module ───
  call_history_title: 'Call History',
  call_history_phone: 'Phone Number',
  call_history_type: 'Call Type',
  call_history_duration: 'Duration',
  call_history_date: 'Date',

  // ─── Error Codes Module ───
  error_code_title: 'Error Codes',
  error_code_name: 'Name',
  error_code_code: 'Code',
  error_code_description: 'Description',

  // ─── Device Errors Module ───
  device_errors_title: 'Device Errors',
  device_errors_product: 'Product',
  device_errors_code: 'Error Code',
  device_errors_solution: 'Solution',

  // ─── Ticket Enhanced Fields ───
  ticket_asc_code: 'ASC Code',
  ticket_asc_name: 'ASC Name',
  ticket_maintance_place: 'Maintenance Place',
  ticket_delivery_place: 'Delivery Place',
  ticket_delivery_to: 'Delivery To',
  ticket_product_status: 'Device Status',
  ticket_receipt_no: 'Receipt Number',
  ticket_cost: 'Cost',
  ticket_currency: 'Currency',
  ticket_resolution: 'Resolution',
  ticket_signature: 'Signature',
  ticket_days_from_create: 'Days Since Creation',
  ticket_company_accounting: 'Company Accounting',
  ticket_notified: 'Notified',
  ticket_place: 'Place',

  // ─── Workflow Module ───
  workflow_title: 'Workflow',
  workflow_step: 'Step',
  workflow_status: 'Status',
  workflow_date: 'Date',

  // ─── Cash Transactions Module ───
  cash_transaction_title: 'Cash Transactions',
  cash_transaction_new: 'New Transaction',
  cash_transaction_amount: 'Amount',
  cash_transaction_type: 'Type',
  cash_transaction_date: 'Date',
  cash_transaction_partner: 'Partner',
  cash_transaction_ticket: 'Ticket',

  // ─── Smart Actions ───
  smart_action_create_invoice: 'Create Invoice',
  smart_action_view_invoice: 'View Invoice',
  smart_action_add_maintenance: 'Maintenance Action',
  smart_action_request_parts: 'Request Parts',
  smart_action_schedule: 'Schedule',
  smart_action_postpone: 'Postpone',
  smart_action_cancel: 'Cancel',
  smart_action_reopen: 'Reopen',
  smart_action_confirm: 'Confirm',
  smart_action_start_work: 'Start Work',
  smart_action_end_work: 'End Work',
  smart_action_more: 'More',

  // ─── Invoice Dialog ───
  invoice_create_title: 'Create Invoice',
  invoice_create_desc: 'An invoice will be created directly with current ticket data',
  invoice_customer: 'Customer',
  invoice_ticket: 'Ticket',
  invoice_product: 'Product',
  invoice_cost: 'Cost',
  invoice_create_direct: 'Create Invoice Directly',
  invoice_existing: 'An invoice is already linked',
  invoice_no_customer: 'Customer must be set before creating invoice',

  // ─── Maintenance Dialog ───
  maintenance_add_title: 'Add Maintenance Action',
  maintenance_add_desc: 'Add a maintenance action linked to accounting',
  maintenance_action_type: 'Action Type',
  maintenance_action_name: 'Action Name',
  maintenance_description: 'Description',
  maintenance_duration: 'Duration (hours)',
  maintenance_cost: 'Cost',
  maintenance_account: 'Maintenance Account',
  maintenance_employee: 'Technician',
  maintenance_type_inspection: 'Inspection',
  maintenance_type_repair: 'Repair',
  maintenance_type_replacement: 'Replacement',
  maintenance_type_maintenance: 'Maintenance',
  maintenance_type_installation: 'Installation',
  maintenance_type_other: 'Other',

  // ─── New Ticket Fields ───
  ticket_cancel_reason: 'Cancel Reason',
  ticket_invoice_lines: 'Invoice Lines',
  ticket_spare_part_ids: 'Spare Parts',
  ticket_maintenance_actions: 'Maintenance Actions',
};

export default en;
export type TranslationKey = keyof typeof en;
